import styled from '@emotion/styled';
import { Box, Stack, Tab, Tabs, Tooltip } from '@mui/material'
import React from 'react'
import { COLOR_MAP } from '../../../../constants/ColorNames';
import Scroller from '../../../../common/components/Scroller';
import { useDispatch, useSelector } from 'react-redux';
import { setOutreachType } from '../../../../redux/slice/campaignSlice';
import TrendUp from '../../../../constants/icons/TrendUp';
import AlertIcon from '../../../../constants/icons/AlertIcon';
import { BLAST_MESSAGE_LIST, SCHEDULED_MESSAGE_LIST } from '../../../../constants/helpers';
import Tick from '../../../../constants/icons/Tick';
import { RootState } from '../../../../redux/store';
import { BoxMessage } from '../../../../common/components/CustomMuiComponents';

const StyledTab = styled(Tabs)`
  border-radius: 3.6rem;
  background-color: ${COLOR_MAP.DISABLED};
  padding: 0.5px;

  .MuiButtonBase-root{
    font-size: 1.3rem;
    font-weight: 600;
    padding: 0.8rem 1.2rem;
  }

  .MuiTabs-flexContainer {
    justify-content: space-between;
  }

  .Mui-selected {
    color: ${COLOR_MAP.DARK_PURPLE} !important;
    background: ${COLOR_MAP.WHITE};
    border:0.1rem solid ${COLOR_MAP.DARK_PURPLE};
    border-radius: 3.6rem;
  }

  .Mui-disabled {
    pointer-events: unset !important;
    cursor: not-allowed !important;
  }

  .MuiTabs-indicator {
    display: none
  }
`


const getActiveIcon = (activeTab: string, index: number) => {
  let icon;
  if(activeTab === 'SCHEDULED'){
    if(index !== 0){
      icon = <Tick/>
    }
    else {
      icon = <TrendUp/>
    }
  }
  else{
    icon = <AlertIcon fill={COLOR_MAP.GREY_2}/>
  }
  return icon;
}
const ScrollerContent = (props: { activeTab: string, children: string, index: number }) => {
  const { activeTab, children, index } = props;
  const activeColor = activeTab === 'SCHEDULED' ? COLOR_MAP.NOTIFICATION_BOX : COLOR_MAP.WARNING;
  const ACTIVE_ICON = getActiveIcon(activeTab, index);
  
  return (
    <BoxMessage sx={{
      backgroundColor: activeColor
    }}>
      {ACTIVE_ICON }
      {children}
    </BoxMessage>
  )
}

const CampaignDetailsTab = () => {
  const [activeTab, setActiveTab] = React.useState('SCHEDULED');
  const dispatch = useDispatch();
  const isMaxBlastLimitReached = useSelector((state: RootState) => state.campaign.isMaxBlastLimitReached);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
    dispatch(setOutreachType({outreachType: newValue}))
  };

  const activeTabMessages = activeTab === 'SCHEDULED' ? SCHEDULED_MESSAGE_LIST : BLAST_MESSAGE_LIST;

  return (
    <Stack rowGap={'1rem'}>
      <Stack>
        <StyledTab value={activeTab} onChange={handleChange} aria-label="basic tabs example">
          <Tab sx={{
            whiteSpace:"nowrap",
            flex: 1
          }} label="Schedule Campaign" value={'SCHEDULED'}/>
          {
            isMaxBlastLimitReached ?
            <Tooltip title={isMaxBlastLimitReached? <div style={{fontSize: '14px'}}>The daily Limit for your account has lapsed. Please create a maximise response campaign </div> : ''}>
            <Tab sx={{
            whiteSpace:"nowrap",
            flex: 1
          }} disabled={isMaxBlastLimitReached} label="Send Immediately" value={'BLAST'}/>
          </Tooltip>
          : 
          <Tab sx={{
            whiteSpace:"nowrap",
            flex: 1
          }}  label="Send Immediately" value={'BLAST'}/>
          }
         
        </StyledTab>
      </Stack>
      <Stack sx={{
        marginBottom: '1.6rem'
      }}>
        {/* <Scroller key={activeTab}> */}
          {activeTabMessages && activeTabMessages.length ? activeTabMessages.map((text: string, index:number) => <ScrollerContent key={`${activeTab}_${index}`} index={index} activeTab={activeTab}>{text}</ScrollerContent>) : null}
        {/* </Scroller> */}
      </Stack>
    </Stack>
  )
}

export default CampaignDetailsTab